export default {"src":"/_next/static/media/data-privacy-implementation.8faa2589.svg","height":854,"width":854,"blurWidth":0,"blurHeight":0};